// extracted by mini-css-extract-plugin
module.exports = {"colorRed":"#ed4c47","cta":"landingCTA_cta__3hdOY"};